function n(e){return e!==void 0}export{n as a};
